import logger from '../services/logging/logging-service';
/**
 *
 * @param {Object} date is a new Date() object
 * @param {Object} intlFormatOptions format options for Intl.DateTimeFormat
 * @returns { day, month, year} - i.e. 21 Novembre 2021
 */
export const getDateFormatted = (date, intlFormatOptions) => {
  const day = date.getDate();
  const month = new Intl.DateTimeFormat('it-IT', intlFormatOptions).format(date);
  const year = date.getFullYear();
  return { day, month, year };
};

const DEFAULT_MAX_HOURS_VALUE = 24;
const CURRENT_DATE_AND_TIME = new Date();
const MS_PER_MINUTE = 60000;
const MS_PER_HOUR = MS_PER_MINUTE * 60;
const MS_PER_DAY = MS_PER_HOUR * DEFAULT_MAX_HOURS_VALUE;

const publishMinutesString = (minutesDifference) => `PUBBLICATO ${minutesDifference} MINUTI FA`;

const publishMinuteString = (minutesDifference) => `PUBBLICATO ${minutesDifference} MINUTO FA`;

const publishHoursString = (hoursDifference) => `PUBBLICATO ${hoursDifference} ORE FA`;

const publishHourString = (hoursDifference) => `PUBBLICATO ${hoursDifference} ORA FA`;

const publishDaysString = (dateString) => `PUBBLICATO ${dateString} GIORNI FA`;

/**
 * accepts a date and time string and returns a new Date() object
 * @param {string} dateString  - i.e. "31/08/2023 15:43:31"
 * @returns {Object} - i.e. Thu Aug 31 2023 15:42:14 GMT+0200 (Central European Summer Time)
 */
export const parseDate = (dateString) => {
  const [day, month, year, hours, minutes, seconds] = dateString.split(/[/ :]/);
  return new Date(`${year}-${month}-${day}T${hours}:${minutes}:${seconds}`);
};

/**
 * calculates the time elapsed between now and the @param publicationDateString returns the correct string
 * @param {string} publicationDateString - i.e. "31/08/2023 15:43:31"
 * @returns {string}  - i.e. PUBBLICATO 2 ORE FA
 */

export const getTimeElapsed = (publicationDateString) => {
  const publicationDate = parseDate(publicationDateString);
  const timeDifferenceMs = CURRENT_DATE_AND_TIME - publicationDate;
  const minutesDifference = Math.floor(timeDifferenceMs / MS_PER_MINUTE);
  const hoursDifference = Math.floor(timeDifferenceMs / MS_PER_HOUR);
  const daysDifference = Math.floor(timeDifferenceMs / MS_PER_DAY);
  if (hoursDifference < DEFAULT_MAX_HOURS_VALUE) {
    if (hoursDifference === 0 && minutesDifference > 0) {
      return minutesDifference === 1 ? publishMinuteString(minutesDifference) : publishMinutesString(minutesDifference);
    }
    return hoursDifference === 1 ? publishHourString(hoursDifference) : publishHoursString(hoursDifference);
  }
  return publishDaysString(daysDifference);
};
